module.exports = __webpack_public_path__ + "static/media/speaker_Harbin_wenjieLu.9548ac13.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/conf/speaker/speaker_Harbin_wenjieLu.jpg
// module id = 242
// module chunks = 0